import React from 'react';

import { Divider, LoadingOverlay, Paper, Stack, Text, Title } from '@mantine/core';
import useAutoCompleteGoogleCalendars from 'hooks/googleCalendar/useAutoCompleteGoogleCalendars';

import ConflictCalendarToggle from './ConflictCalendarToggle';

interface ConflictCheckingCardProps {
  googleCalendarIntegrationId: string;
}

const ConflictCheckingCard = ({ googleCalendarIntegrationId }: ConflictCheckingCardProps): JSX.Element => {
  const { data, isLoading, refetch, error } = useAutoCompleteGoogleCalendars({
    googleCalendarIntegrationId: googleCalendarIntegrationId,
    ordering: 'created_at',
  });

  const hasCalendars = data?.data && data.data.length > 0;

  return (
    <Paper radius='lg' p='xl' shadow='xs' withBorder>
      <LoadingOverlay visible={isLoading} />
      <Stack>
        <Stack spacing='xs'>
          <Title order={3}>Conflict Checking</Title>
          <Text color='dimmed'>
            Select which calendars you want to check for conflicts to prevent double bookings
          </Text>
        </Stack>

        <Divider mx='-xl' />

        {!!error && <Text color='red'>Failed to load calendars. Please refresh and try again.</Text>}

        {!error && !isLoading && !hasCalendars && googleCalendarIntegrationId && (
          <Text color='dimmed'>
            No calendars found. Connect to Google Calendar first or refresh your calendars.
          </Text>
        )}

        {!error && !isLoading && !googleCalendarIntegrationId && (
          <Text color='dimmed'>Connect to Google Calendar to manage conflict settings.</Text>
        )}

        {hasCalendars &&
          data?.data.map(gc => (
            <ConflictCalendarToggle
              key={gc.googleCalendarId}
              googleCalendar={gc}
              refetchCalendarList={refetch}
            />
          ))}
      </Stack>
    </Paper>
  );
};

export default ConflictCheckingCard;
